// - Import action types
import { ServerActionType } from 'constants/serverActionType';
/**
 * Add a request
 * @param {Request} request
 */
export var sendRequest = function (request) {
    return { type: ServerActionType.ADD_REQUEST, payload: { request: request } };
};
/**
 * delete a request
 */
export var deleteRequest = function (requestId) {
    return { type: ServerActionType.DELETE_REQUEST, payload: { requestId: requestId } };
};
/**
 * Update request stattus ti successful
 */
export var okRequest = function (requestId) {
    return { type: ServerActionType.OK_REQUEST, payload: { requestId: requestId } };
};
/**
 * Set error request
 */
export var errorRequest = function (requestId, error) {
    return { type: ServerActionType.ERROR_REQUEST, payload: { requestId: requestId, error: error } };
};
/**
 * Clear all data
 */
export var clearAllrequests = function () {
    return { type: ServerActionType.CLEAR_ALL_DATA_REQUEST };
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/serverActions.ts
// module id = 161
// module chunks = 50